import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { message } from 'antd';
import S3Upload from './S3Upload';
import { env } from '../utils/globals';

import MUTATION from '../graphql/mutations/customerDocUploadedMutation.graphql';
import ALL_TASKS from '../graphql/queries/getCustomerTasksQuery.graphql';

class CustomerDocUpload extends Component {
  constructor(props) {
    super(props);
    this.fileName = Math.random().toString(36).substring(2, 12) + Math.random().toString(36).substring(2, 12) + Math.random().toString(36).substring(2, 12);
  }

  onChange = (info) => {
    const { customerDoc, task_id, customer_id } = this.props;

    if (info.file.status === 'done') {
      this.props.mutate({
        variables: { doc_id: customerDoc.id, task_id, s3_path: `${env}/customer_docs/${this.fileName}` },
        update: (cache, { data: { newTask } }) => {
          const data = cache.readQuery({
            query: ALL_TASKS,
            variables: { customer_id },
          });

          for (let i = 0; i < data.tasks.length; i++) {
            if (data.tasks[i].id === parseInt(task_id, 10)) {
              data.tasks[i].completed = true;
              break;
            }
          }
          data.tasks.push(newTask);

          cache.writeQuery({ query: ALL_TASKS, variables: { customer_id }, data });
        },
      })
        .then(() => {
          message.success('Document Uploaded!');
        })
        .catch((mutateErr) => {
          console.log(mutateErr);
          message.error(mutateErr.message);
        });
    }
  };

  render() {
    return (
      <S3Upload s3Key={`${env}/customer_docs/${this.fileName}`} onChange={this.onChange} fileName={this.props.customerDoc.filename} buttonText={this.props.buttonText} />
    );
  }
}

CustomerDocUpload.propTypes = {
  customerDoc: PropTypes.shape({
    id: PropTypes.number.isRequired,
    filename: PropTypes.string,
  }).isRequired,
  task_id: PropTypes.number.isRequired,
  mutate: PropTypes.func.isRequired,
  customer_id: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
};

CustomerDocUpload.defaultProps = {
  buttonText: null,
};

export default graphql(MUTATION)(CustomerDocUpload);



// WEBPACK FOOTER //
// ./src/components/CustomerDocUpload.jsx